import type { AdminConnectorSummary } from '@/versions/v1/shared/admin-seed';

import { formatAdminDateTime } from './admin-format';

export type ConnectorAuthPill = 'API key' | 'OAuth' | 'OAuth + API key';

const AUTH_PILL_BY_TYPE: Record<AdminConnectorSummary['authType'], ConnectorAuthPill> = {
  api_key: 'API key',
  oauth: 'OAuth',
  oauth_api_key: 'OAuth + API key',
};

export function connectorAuthPill(connector: AdminConnectorSummary): ConnectorAuthPill {
  return AUTH_PILL_BY_TYPE[connector.authType];
}

export function authPillTone(
  label: ConnectorAuthPill,
): 'success' | 'warning' | 'default' {
  if (label === 'OAuth') return 'success';
  if (label === 'OAuth + API key') return 'warning';
  return 'default';
}

export function filterConnectors(
  connectors: AdminConnectorSummary[],
  query: string,
): AdminConnectorSummary[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return connectors;

  return connectors.filter((connector) => {
    const haystack = `${connector.name} ${connector.marketplaceId} ${connector.transport}`.toLowerCase();
    return haystack.includes(needle);
  });
}

export function usageLabel(installCount: number): string {
  if (installCount <= 0) return '—';
  return `${installCount} ${installCount === 1 ? 'user' : 'users'}`;
}

export function hasStaticOAuth(connector: AdminConnectorSummary): boolean {
  return connector.authType === 'oauth' || connector.authType === 'oauth_api_key';
}

export function oauthCallbackUrl(connectorId: string): string {
  return `https://app.example.com/api/connectors/${connectorId}/oauth/callback`;
}

export function maskedOAuthClientId(last4: string): string {
  return `···${last4}`;
}

export function formatOAuthCredentialSet(epochMs: number): string {
  return formatAdminDateTime(epochMs);
}

export function maskedOAuthClientSecret(): string {
  return '••••••••••••••••';
}
